import "../css/main.css";
import sal from 'sal.js';
import "sal.js/dist/sal.css";
import Alpine from 'alpinejs';
import anchor from '@alpinejs/anchor';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse';
import Tooltip from "@ryangjchandler/alpine-tooltip";


window.Alpine = Alpine;
Alpine.plugin(anchor);
Alpine.plugin(collapse);
Alpine.plugin(Tooltip);
Alpine.plugin(focus);
Alpine.plugin(persist);

import "./_lottie";
import "./_carousel";
import "./_numbers-only.ts";
import "./_product-hero";
import "./_range-hero";
import "./_featured-merch";
import "./_parallax-image-breaker";
import "./_stepped-scroll";
import "./_toggle";
import { initPastProductsCarousels } from "./_past-products-carousel";
import { initAccreditationsCarousels } from "./_accreditations-carousel";
import { initImageCarousels } from "./_image-carousel";
import { initRelatedLinks } from "./_related-links";
import "./_content-hub";
import "./_blog-titles";
import "./_floating-cart";


// if .form-error is present, scroll into view
const el = document.querySelector('.form-error');
if(el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });

sal({
    threshold: 0.25,
    once: true,
});

class ScrollProgressCircle extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        
        // Create the SVG for the progress circle
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    width: 64px;
                    height: 64px;
                    background: #F2F3F5;
                    border-radius: 100%;
                    padding: 3px;
                }
                
                .progress-circle {
                    width: 100%;
                    height: 100%;
                }
                
                .progress-circle-bg {
                    fill: none;
                    stroke: #F2F3F5;
                    stroke-width: 4;
                }
                
                .progress-circle-fill {
                    fill: none;
                    stroke: #000A3C;
                    stroke-width: 4;
                    stroke-linecap: round;
                    transform: rotate(-90deg);
                    transform-origin: center;
                    transition: stroke-dashoffset 0.1s ease;
                }
            </style>
            <svg class="progress-circle" viewBox="0 0 100 100">
                <circle class="progress-circle-bg" cx="50" cy="50" r="45"></circle>
                <circle class="progress-circle-fill" cx="50" cy="50" r="45"></circle>
            </svg>
        `;
        
        this.progressCircle = this.shadowRoot.querySelector('.progress-circle-fill');
        
        // Calculate the circumference of the circle
        const radius = this.progressCircle.getAttribute('r');
        this.circumference = 2 * Math.PI * radius;
        
        // Set the initial dash array and offset
        this.progressCircle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
        this.progressCircle.style.strokeDashoffset = this.circumference;
        
        // Bind the scroll event handler
        this.handleScroll = this.handleScroll.bind(this);
    }
    
    connectedCallback() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll(); // Initialize on load
    }
    
    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    
    handleScroll() {
        // Calculate scroll progress
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollProgress = scrollTop / scrollHeight;
        
        // Update the circle fill based on scroll progress
        const offset = this.circumference - (scrollProgress * this.circumference);
        this.progressCircle.style.strokeDashoffset = offset;
    }
}

// Register the custom element
customElements.define('scroll-progress-circle', ScrollProgressCircle);

Alpine.data('sharing', ((title, text, url, image) => ({
    title: title,
    text: text,
    url: url,
    image: image,
    canShare: 'canShare' in navigator && navigator.canShare(),

    shareToLinkedIn() {
        // Use regular iframe popup method to share to LinkedIn
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(this.url)}&title=${encodeURIComponent(this.title)}&summary=${encodeURIComponent(this.text)}`, 'linkedin-share', 'width=750,height=500');
    },

    shareToX() {
        // Use regular iframe popup method to share to Twitter /X
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(this.text)}&url=${encodeURIComponent(this.url)}`, 'twitter-share', 'width=750,height=500');
    },

    copyLink() {
        // Copy the link to the clipboard
        navigator.clipboard.writeText(this.url).then(() => {
            this.$tooltip('Link copied');
        });
    },

    nativeShare() {
        navigator.share({
            title: title,
            text: text,
            url: url,
        });
    }
})));

Alpine.start();

// if an element with .translate-waves-bottom exists on page load, toggle the display block class off and on to trigger a reflow

function fixReflow() {
    const element = document.querySelector('.translate-waves-bottom');
    setTimeout(() => {
        if (element) {
            // get the transform styles, remove them, wait, then re-add them
            const transform = getComputedStyle(element).transform;
            element.style.transform = 'none';
            element.offsetHeight; // trigger reflow
            setTimeout(() => {
                element.style.transform = transform;
                console.log('done');
            }, 10);
        }
    }, 0);
}

document.addEventListener('DOMContentLoaded', () => {
    fixReflow();
    initPastProductsCarousels();
    initAccreditationsCarousels();
    initImageCarousels();
    initRelatedLinks();
});

setTimeout(() => {
    fixReflow();
}, 500);